import { render, staticRenderFns } from "./FormTextInput2.vue?vue&type=template&id=b81ec948&lang=pug&"
import script from "./FormTextInput2.vue?vue&type=script&lang=js&"
export * from "./FormTextInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports